import React from 'react';

function NotFound() {
  return <h1>Comming soon...</h1>;
}

export default NotFound;